import React from 'react';

function MovieCard({ movie, onToggleFavorite, isFavorite }) {
  return (
    <div className="movie-card">
      <button 
        className={`fav-btn ${isFavorite ? 'favorited' : ''}`}
        onClick={() => onToggleFavorite(movie.id)}
        title={isFavorite ? 'Remove from watchlist' : 'Add to watchlist'}
      >
        {isFavorite ? '🎆' : '🔖'}
      </button>
      <h3>{movie.title}</h3>
      <p className="movie-info">{movie.genre} • {movie.year}</p>
      <p className="director">Directed by {movie.director}</p>
      <p className="rating">⭐ {movie.rating}/10</p>
    </div>
  );
}

export default MovieCard;